'use client';
import type { MouseEventHandler, ReactNode } from 'react';
import { setCookie } from 'cookies-next';
import Link from 'next/link';
import type { LinkProps } from 'next/link';
import { usePathname } from 'next/navigation';

import { useIsCampaignPageType } from '@/app/providers/campaign-type';
import { useExitConfirmationModalContext } from '@/app/providers/exit-confirmation';
import { ENABLE_CAMPAIGNS, EXIT_MODAL_HREF_COOKIE } from '@/constants';


type CustomLinkProps = {
  children: ReactNode;
  href: LinkProps['href'];
  confirmationRequired?: boolean;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  className?: string;
  target?: '_blank' | '_self';
  download?: boolean;
  scroll?: boolean;
  isRichText?: boolean;
};

export const CustomLink = ({
  children,
  href,
  confirmationRequired,
  onClick,
  className,
  target,
  download,
  scroll,
  isRichText = false,
}: CustomLinkProps) => {
  const pathname = usePathname();
  const isSignUp =
    pathname.includes('sign-up') && !pathname.includes('sign-up/confirmation');
  const { setIsModalOpen, setUrl } = useExitConfirmationModalContext();

  const isCampaignPageType = useIsCampaignPageType();

  const handleCookieSet = () => {
    setCookie(EXIT_MODAL_HREF_COOKIE, href as string);
  };

  if (ENABLE_CAMPAIGNS && isCampaignPageType && !pathname.includes('/exit')) {
    return (
      <Link
        href={isRichText ? href : `${pathname}/exit`}
        scroll={isRichText}
        className={className}
        target={isRichText ? '_blank' : '_self'}
        onMouseDown={handleCookieSet}
        onClick={handleCookieSet}
      >
        {children}
      </Link>
    );
  }

  if (confirmationRequired && isSignUp) {
    return (
      <Link
        href=""
        onClick={() => {
          setIsModalOpen(true);
          setUrl(href as string);
        }}
        className={className}
        scroll={scroll}
      >
        {children}
      </Link>
    );
  }

  return (
    <Link
      href={href}
      onClick={onClick}
      className={className}
      target={target}
      download={download}
      scroll={scroll}
    >
      {children}
    </Link>
  );
};
